import React, { useContext, useEffect, useState } from "react";

import styles from "./Footer.module.css";
import botonAdelante from '../../img/btnadelante.png';

//Context
import GeneralContext from '../../context/GeneralContext';

//Actions
import * as GeneralActions from '../../store/actions/generalActions';
import * as GLOBALES from '../../utils/globales'

export const Footer = ({ history, validarPantalla, tipo, saltaProximaOpcion, disabled, juridico }) => {
    const initialState = {
        listaMenu: []
    }
    const [ localState, setLocalState ] = useState(initialState)
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones !== undefined && prospecto.cotizaciones !== null
        ? prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]
        : undefined

    let datos = {}

    const obtenerUrlDestino = (cotizacion, urlDestino) => {
        let tieneCompletados = false
        datos.cotizacion = cotizacion
        localState.listaMenu.map(menu => {
            datos.completado = menu.completado

            //Tiene Compleados
            if(menu.completado) {
                tieneCompletados = true
            }

            //Opcion Destino
            if(urlDestino !== null) {
                if(menu.url === urlDestino) {
                    datos.opcionDestino = menu
                } else {
                    if(menu.listaSubmenu !== undefined && menu.listaSubmenu !== null &&
                        menu.listaSubmenu.length > 0) {
                            menu.listaSubmenu.map(submenu => {
                                if(submenu.url === urlDestino) {
                                    datos.opcionDestino = submenu
                                }
                                return submenu
                            })
                    }
                }
            }
            return menu
        })

        datos.tieneCompletados = tieneCompletados

        return datos
    }

    const obtenerSiguienteUrl = (cotizacion, urlOrigen) => {
        localState.listaMenu.map((menu, indexMenu) => {
            datos.completado = menu.completado
            if(menu.url && menu.url === urlOrigen) {
                let siguienteMenu = localState.listaMenu[indexMenu + 1]
                if(siguienteMenu === undefined) {
                    datos.opcion = {
                        url: '/prospectoFinal'
                    }
                } else if(siguienteMenu.url) {
                    datos.opcion = siguienteMenu
                } else {
                    datos.opcion = siguienteMenu.listaSubmenu[0]
                }
            } else {
                if(menu.listaSubmenu !== undefined && menu.listaSubmenu !== null && menu.listaSubmenu.length > 0) {
                    menu.listaSubmenu.map((submenu, indexSubmenu) => {
                        if(submenu.url && submenu.url === urlOrigen) {
                            if(indexSubmenu === menu.listaSubmenu.length - 1) {
                                datos.opcion = localState.listaMenu[indexMenu + 1]
                            } else {
                                datos.opcion = menu.listaSubmenu[indexSubmenu + 1]
                            }
                        }
                        return submenu
                    })
                }
            }

            return menu
        })

        return datos
    }

    const handleContinuar = async() => {
        if(cotizacion !== undefined && cotizacion.edicionInhabilitada) {
            //CMUNAYLLA: se agrega condición para validar si tiene estado firmado sin pago (2)/pago incompleto (6)/firma en proceso(12)
            if ((cotizacion.codigoEstado === 2 || cotizacion.codigoEstado === 6 || cotizacion.codigoEstado === 12) 
                && history.location.pathname === '/primerPago') {
                generalDispatch(GeneralActions.continuarProceso(history.location.pathname))
                history.push('/prospectoFinal')
                generalDispatch(GeneralActions.finalizarProspecto())
            } else {
                if ((cotizacion.codigoEstado === 2 || cotizacion.codigoEstado === 6 || cotizacion.codigoEstado === 12) 
                    && history.location.pathname === '/firma' && !juridico) {
                        generalDispatch(GeneralActions.continuarProceso('/firma'))
                        history.push('/primerPago')
                } else if (juridico) {
                    generalDispatch(GeneralActions.continuarProceso('/firma'))
                    generalDispatch(GeneralActions.continuarProceso('/primerPago'))
                    history.push('/prospectoFinal')
                } else {
                    let datos = obtenerSiguienteUrl(cotizacion, history.location.pathname)
                    if (saltaProximaOpcion) {
                        generalDispatch(GeneralActions.continuarProceso('/requisitos'))
                        history.push('/firma')
                    } else {
                        generalDispatch(GeneralActions.continuarProceso(history.location.pathname))
                        history.push(datos.opcion.url)
                    }
                }
            }
        } else {
            generalDispatch(GeneralActions.updateEstadoCargando(true))
            let validacion = validarPantalla !== undefined ? await validarPantalla() : true
            let proximo = null
            if (saltaProximaOpcion) {
                proximo = validacion.next
            }
            generalDispatch(GeneralActions.updateEstadoCargando(false))
            if(validacion) {
                //Redirigir al siguiente punto
                let datos = obtenerSiguienteUrl(cotizacion, history.location.pathname)
                generalDispatch(GeneralActions.continuarProceso(history.location.pathname))

                if(datos.completado) {
                    history.push('/prospectoFinal')
                    generalDispatch(GeneralActions.finalizarProspecto())
                } else if(proximo) {
                    generalDispatch(GeneralActions.continuarProceso('/requisitos'))
                    history.push('/firma')
                } else if (juridico) {
                    generalDispatch(GeneralActions.continuarProceso('/firma'))
                    generalDispatch(GeneralActions.continuarProceso('/primerPago'))
                    history.push('/prospectoFinal')
                } else {
                    history.push(datos.opcion.url)
                    //CMUNAYLLA: se agrega condición para validar si tiene estado firmado sin pago (2)/pago incompleto(6)/firma en proceso(12)
                    /*if (cotizacion.codigoEstado === 2 || cotizacion.codigoEstado === 6 || cotizacion.codigoEstado === 12) {
                        history.push('/primerPago')
                    }*///PENDIENTE DE VALIDAR
                }
            }
        }
    }

    const handleContinuarError = () => {
        generalDispatch(GeneralActions.updateError({mensajeRespuesta: 'Corregir los errores pendientes.'}, '¡Alerta!'))
    }

    useEffect(() => {
        //Cargando Lista de Menu
        let listaMenu = null
        if(prospecto.cotizaciones !== null && prospecto.cotizaciones !== undefined) {
            prospecto.cotizaciones.map(cotizacion => {
                if(cotizacion !== undefined && cotizacion.isSelected) {
                    listaMenu = cotizacion.listaMenu
                }
                return cotizacion
            })
        }

        listaMenu = listaMenu !== null ? listaMenu : GLOBALES.LISTA_MENU_INICIAL
        setLocalState((localState) => {
            return {
                listaMenu: listaMenu
            }
        })

        //SOLO PARA REDIRECCIONES
        let datos = obtenerUrlDestino(cotizacion, history.location.pathname)
        if(datos.opcionDestino !== undefined &&
            datos.opcion !== undefined &&
            history.location.pathname !== datos.opcion.url) {
            if(datos.opcionDestino.completado) {
                // if(datos.cotizacion.inicioFlujo && datos.tieneCompletados) {
                //     let opcionAnterior = obtenerAnteriorUrl(datos.opcion)
                //     generalDispatch(GeneralActions.actualizarProspecto())
                //     history.push(opcionAnterior.url)
                // } else {
                //     history.push(datos.opcionDestino.url)
                // }
                history.push(datos.opcionDestino.url)
            } else {
                history.push(datos.opcion.url)
            }
        } else {
            if(cotizacion !== undefined && cotizacion.completado) {
                history.push('/prospectoFinal')
            }
        }
    }, [ history, generalDispatch, cotizacion ])

    return (
        tipo === undefined
            ? <div className={styles['grupobtnav']}>
                <div></div>
                <div
                    onClick={disabled !== null && disabled !== undefined && disabled
                        ? handleContinuarError : handleContinuar}
                    className={styles['areanavfooter']}
                    style={ disabled ? { filter: 'grayscale(100%)' } : {}}
                >
                    <label>Continuar</label>
                    <img src={botonAdelante} alt="" className={styles['imgadelante']}/>
                </div>
            </div>
            : <button
                onClick={disabled !== null && disabled !== undefined && disabled
                    ? handleContinuarError : handleContinuar}
                className={styles['btningresar']}
                style={disabled !== null && disabled !== undefined && disabled
                    ? {opacity: 0.5} : null}>
                        Empezar Solicitud
            </button>
    )
}

export default Footer;